var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rounded p-5 gutter-b gutter-t border border-light bg-light-primary"},[_c('b-icon-info-circle-fill',{staticClass:"mr-3",attrs:{"variant":"primary"}}),_c('span',{staticClass:"text-primary"},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('p',{staticClass:"text-muted pt-4 pl-8 font-size-h6"},[_vm._v(" "+_vm._s(_vm.text)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }